import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="hero-bg max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center"
    >
      <Seo title="Not found" description="This page could not be found." />
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#9a6700]">
        404
      </p>
      <h1 className="font-poster uppercase text-5xl sm:text-6xl text-[#0b1f4d] mt-3 tracking-tight">
        Page not found
      </h1>
      <p className="mt-4 text-[#4d5a78]">
        The page you're looking for doesn't exist or may have moved.
      </p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="mt-8 inline-flex items-center gap-2 rounded-sm bg-[#f5b61c] hover:bg-[#dda00d] text-[#0a1630] font-semibold uppercase tracking-wide px-6 py-3 transition-colors"
      >
        <Home size={17} /> Back home
      </Link>
    </div>
  );
}
